import { TableBody, TableCell, TableRow, TableHead, TableContainer, Paper, Table } from '@mui/material'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectCourse } from 'store/course/slice'
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ProviderSearchCourses from './CourseProviderSearchCourses'
import { selectClub } from 'store/club/slice'
import LoadingSpinnerGreen from 'components/ui/LoadingSpinnerGreen'

enum STATUS {
  MAPPED = 'Mapped',
  ACTIVATED = 'Activated',
}

interface Props {
  searchResult: ProviderSearchClubs[] | undefined
  showClubs: boolean
}

export default function CourseProviderSearchClubs({ searchResult, showClubs }: Props) {
  const intl = useIntl()
  const { course, getProviderCoursesStatus } = useSelector(selectCourse)
  const { club } = useSelector(selectClub)

  const columns: TableColumn[] = [
    {
      id: 'provider',
      label: intl.formatMessage({ id: 'strings.provider' }),
    },
    {
      id: 'clubId',
      label: intl.formatMessage({ id: 'strings.clubId' }),
    },
    {
      id: 'providerClubId',
      label: intl.formatMessage({ id: 'strings.providerClubId' }),
    },
    {
      id: 'clubName',
      label: intl.formatMessage({ id: 'strings.clubName' }),
    },
    {
      id: 'providerClubName',
      label: intl.formatMessage({ id: 'strings.providerClubName' }),
    },
    {
      id: 'active',
      label: intl.formatMessage({ id: 'strings.ggbStatus' }),
    },
    {
      id: 'status',
      label: intl.formatMessage({ id: 'strings.mappingStatus' }),
    },
    {
      id: 'providerStatus',
      label: intl.formatMessage({ id: 'strings.providerStatus' }),
    },
  ]

  if (getProviderCoursesStatus === 'loading') {
    return (
      <LoaderContainer>
        <LoadingSpinnerGreen size={92} />
      </LoaderContainer>
    )
  }

  if (!showClubs) {
    return
  }

  return (
    <TableContainer component={Paper} sx={{ marginTop: '15px' }}>
      <Table aria-label="simple table">
        <StyledTableHead>
          <TableRow sx={{ backgroundColor: '#11A85D' }}>
            {columns.map((info, index) => {
              return <TableCell key={index}>{info.label}</TableCell>
            })}
          </TableRow>
        </StyledTableHead>
        <TableBody>
          {searchResult &&
            searchResult.map((Clubs) => {
              return (
                <React.Fragment key={Clubs.providerClubId}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: '500' }}>{Clubs.providerAbbreviation}</TableCell>
                    <TableCell>{Clubs.id}</TableCell>
                    <TableCell>{Clubs.providerClubId}</TableCell>
                    <TableCell>{Clubs.name}</TableCell>
                    <TableCell>{Clubs.providerClubName}</TableCell>
                    <TableCell
                      sx={{
                        color: Clubs.activated === STATUS.ACTIVATED ? '#11A85D' : 'red',
                      }}
                    >
                      {Clubs.activated}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: Clubs.mapped === STATUS.MAPPED ? '#11A85D' : 'red',
                      }}
                    >
                      {Clubs.mapped}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: Clubs.providerActivated === STATUS.ACTIVATED ? '#11A85D' : 'red',
                      }}
                    >
                      {Clubs.providerActivated}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={columns.length} sx={{ padding: '0', paddingBottom: '10px', borderTop: 'grey' }}>
                      <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>Provider Courses</AccordionSummary>
                        <AccordionDetails>
                          <ProviderSearchCourses
                            providerCourses={Clubs.courses}
                            course={course}
                            provider={Clubs.providerAbbreviation}
                            clubMappingStatus={Clubs.mapped}
                            providerClubId={Clubs.providerClubId}
                            club={club}
                          />
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              )
            })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const StyledTableHead = styled(TableHead)`
  background-color: ${(props) => props.theme.palette.primary.dark};
  height: 40px;
  & th,
  span,
  span.MuiTableSortLabel-active {
    color: ${(props) => props.theme.customPalette.light};
    font-size: 13px;
    line-height: 15px;
    text-transform: uppercase;
  }
  & span:hover {
    color: ${(props) => props.theme.customPalette.light};
    opacity: 0.8;
  }
  & svg {
    color: #fff !important;
  }
`

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
